/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import loadingConfig from '@pages/ActualPolicyPage/config/loading.config.json';
import headerConfig from '@pages/ActualPolicyPage/config/header.config.json';
import errorConfig from '@pages/ActualPolicyPage/config/error.config.json';
import emptyConfig from '@pages/ActualPolicyPage/config/empty.config.json';
import settingsConfig from '@pages/ActualPolicyPage/config/settings.config.json';
// import { vappContainer } from "@/application";
// import { BreadcrumbService } from "@services/breadcrumbService";

// const getBreadcrumbService = () => {
//   return vappContainer.get<BreadcrumbService>(BreadcrumbService.displayName);
// };

export interface IStaticContentPluginMethods extends IPluginMethodMap {
  getStaticContentSync(args?: any): any;
}

export class StaticContentPlugin implements IAgentPlugin {
  readonly methods: IStaticContentPluginMethods;

  constructor() {
    this.methods = {
      getStaticContentSync: this.getStaticContentSync.bind(this),
    };
  }

  getStaticContentSync(args?: any) {
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: { ...headerConfig },
      loading: loadingConfig?.loading,
      empty: emptyConfig,
      error: errorConfig,
      settings: settingsConfig,
    };
  }
}
